import {Component} from '@angular/core';
import {PatientSideNavComponent} from "./patient-side-nav/patient-side-nav.component";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {RouterOutlet} from "@angular/router";
import {PatientDetailsComponent} from "./patient-details/patient-details.component";
import {PatientNavComponent} from "./patient-nav/patient-nav.component";

/** Base page for a selected appointment */
@Component({
	selector: 'app-patient',
	imports: [
		PatientSideNavComponent,
		MatButtonModule,
		MatIconModule,
		PatientDetailsComponent,
		RouterOutlet,
		PatientNavComponent
	],
	templateUrl: './patient.component.html',
	styleUrl: './patient.component.scss'
})
export class PatientComponent {
}
